"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_get_1 = __importDefault(require("lodash.get"));
const index_1 = require("../index");
exports._resolveServerCookie = (serverCookies) => {
    return lodash_get_1.default(serverCookies, index_1.COOKIE_LOOKUP_KEY_LANG, undefined);
};
exports.serverCookie = (serverCookies) => {
    return {
        name: 'serverCookie',
        lookup: (options) => {
            return exports._resolveServerCookie(serverCookies);
        },
        cacheUserLanguage: () => {
        },
    };
};
exports.default = exports.serverCookie;
//# sourceMappingURL=serverCookie.js.map